import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Tabs,
    Row,
    Typography,
    notification,
     Select,
     Switch,
     Modal,Form, Skeleton
} from 'antd';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    EyeFilled,
    DeleteFilled,
    MinusCircleOutlined,
    PlusOutlined,
    EditFilled, UnlockFilled, LockFilled,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import Parameters from 'shared/parameters';
import API_SERVICE from 'shared/services/api-service';
import vDOts from '../../../src/img/v-dots.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import MeetingsPage from '../Meetings/MeetingsPage';
import ReviewsPage from '../Reviews/ReviewsPage';
import moment from 'moment';
import CloseImg from "../../img/close.png";
import OpenImg from "../../img/open-close.png";
import {
    ArrowLeftOutlined,
} from '@ant-design/icons';
import { Collapse } from 'antd';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';

const { Panel } = Collapse;


interface Props {
    location: any;
}
const { confirm } = Modal;
const { TabPane } = Tabs;
const { Title } = Typography;
const { Option } = Select;
export default function ContentList(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [fetching, setFetching] = useState(false);
    const [curriculumItems, setCurriculumItems] = useState(null as any);
    const [contentItems, setContentItems] = useState([] as any[]);
    const [moduleId, setModuleId] = useState(null as any);
    const [deletingItem, setDeletingItem] = useState(false);
    const [typeContent, setContentType] = useState(null as any);
    const [quesItems, setQuesItems] = useState([] as any[]);
    const [quizId, setQuizId] = useState(null as any);
    const [deletingQuesItem, setDeletingQuesItem] = useState(false);
    const [item, setItem] = useState([] as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [lang, setLang] = useState('' as any);
    let i = 0;
    let iQuiz = 0;
    let iItem = 0;

    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchCourseByIdAdmin(RouteParams['id']);
            setItem({
                ...data,
                instructor_id: data.user_id,
            });
            console.log('item in function',item)
            setImage({ image: getImageUrl(data.thumbnail), imageId: data.thumbnail_id });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };

    const refreshCurriculumItems = async () => {
        try {
            setFetching(true);
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchCurriculumsAdmin(RouteParams['id'], {
                order_by: 'sort_order',
                page: 1,
                order: 'ASC',
            });
            setCurriculumItems(items);
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };

    const refreshContentItems = async () => {
        try {
            setFetching(true);
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchContentsAdmin(RouteParams['id'], moduleId, {
                order_by: 'sort_order',
                page: 1,
                order: 'ASC',
                fetch_by_course: 'true'
            });
            setContentItems(items);
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };

    const refreshQuesItems = async () => {
        try {
            // setFetching(true);
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchQuestionsAdmin(RouteParams['id'], moduleId, quizId, {
                order_by: 'id',
                page: 1,
                order: 'DESC',
                notFetchByContent: 'true'
            });
            setQuesItems(items);
            
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        refreshCurriculumItems();
        refreshContentItems();
        refreshQuesItems();
        setLang(localStorage.getItem('language'));
    }, []);
    if(fetching){
        return <Skeleton active={true} />;
    }
    return (
        <AuthConsumer>
            {({ user }) => (
                (user?.id == item.instructor_id) || user?.role?.id == 2 && (user?.role?.slug !== 'STUDENT') ?
                    
                    <>
                    <div className='d-md-flex'>
                        {setFetching(false)}
                        <FrontendSidebar menuSelect={2} />
                        
                        <div className={Parameters.Mode === 'CLIENT' ? 'profile-tab-content-div mb-3': 'mb-3'} style={{width: '100%'}}>
                            <div className={'list-page-wrapper'}>
                            <div className="row">
                                <div className="col-sm-6 pb-3">
                                    {console.log('itemitemitemitemitemitem', item)}
                                    <div className="d-flex">
                                        <div className="mr-3">
                                            <img src={image.image} className="uploaded-img-cat" height="50" width="50" />
                                        </div>
                                        <div className={lang == 'ar' ? 'mr-2' : ''}>
                                            {console.log('item in html', item)}
                                            <p className="mb-0 font-18px">
                                                <span>
                                                    {item.id ?
                                                        Parameters.DefaultLang === 'de' ? item.title.de : Parameters.DefaultLang === 'en' ? item.title.en : ''
                                                        : ''}
                                                </span>
                                            </p>
                                            <a type='button' className="btn btn-sm btn-default mt-2" onClick={() => {
                                                history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${item.id}/details`);
                                            } }>{t('genDict.ViewDetail')}</a>
                                        </div>
                                    </div>

                                </div>
                                <div className={lang === 'ar' ? 'col-sm-6 pb-3 my-auto' : "col-sm-6 pb-3 text-sm-right my-auto"}>
                                    {/* <span className="text-secondary small mr-4">Created on {item ? moment(item.created_at).format('DD MMMM, YYYY') : ''}</span> */}
                                    <span className="text-secondary small mr-4">{t('genDict.CreatedOn')} {item ? moment(item.created_at).format('DD MMMM, YYYY') : ''}</span>
                                    <span className="dropdown">
                                        <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                                            <img className='cursor-pointer' src={vDOts} style={{ width: '20px' }} />
                                        </a>
                                        <div className="dropdown-menu">
                                            <a className="dropdown-item" role="button"
                                                onClick={() => {
                                                    history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${item.id}/edit`);
                                                } }
                                            >Edit</a>
                                            <a className="dropdown-item" role="button"
                                                onClick={() => confirm({
                                                    icon: <ExclamationCircleOutlined />,
                                                    title: t('genDict.confirmDelete'),
                                                    okText: t('genDict.ok'),
                                                    cancelText: t('genDict.cancel'),
                                                    content: `${t('genDict.confirmDelete')} "${item.id ?
                                                            Parameters.DefaultLang === 'de' ? item.title.de : Parameters.DefaultLang === 'en' ? item.title.en : ''
                                                            : ''}"`,
                                                    okButtonProps: { loading: deletingItem, danger: true },
                                                    onOk: async () => {
                                                        setDeletingItem(true);
                                                        API_SERVICE.removeCourse(RouteParams['id']).then((d) => {
                                                            notification.success({
                                                                message: t('genDict.success'),
                                                            });
                                                            history.push('/courses/');
                                                        }).catch((e: any) => {
                                                            notification.error({
                                                                message: t(API_SERVICE.handleErrors(e)),
                                                            });
                                                        }).finally(() => {
                                                            setDeletingItem(false);
                                                        });
                                                    },
                                                })}
                                            >{t('genDict.delete')}</a>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <hr></hr>
                            <div>
                                <Tabs>
                                    <TabPane tab={t('genDict.Module')} key={1}>
                                        <div className='contentCollapse'>
                                            <Collapse defaultActiveKey={['1']} onChange={() => { } }>
                                                {curriculumItems && curriculumItems.map((curriculumItem: any) => {
                                                    return <Panel header={<><div onClick={() => { setModuleId(curriculumItem.id); } }>
                                                        <div>
                                                            <h6 className="mb-0"><span className="mr-2">{t('genDict.Module')} {iItem = iItem + 1}:</span><span>{curriculumItem.title}</span></h6>
                                                        </div>
                                                        <div className='d-flex align-items-center justify-content-space-between mt-2'>
                                                            <div className={lang == 'ar' ? 'text-right' : ''}>
                                                                <div className='float-left'>

                                                                </div>
                                                                <ul className='list-style-none d-flex'>
                                                                {/* <ul className={lang == 'ar' ? 'text-right' : 'list-style-none d-flex'}> */}
                                                                    <li className='text-center small bg-transparent pl-3 pr-3 text-secondary'>
                                                                        <span>{t('genDict.content')}</span><br></br>
                                                                        <span>{curriculumItem?.content_count}</span>
                                                                    </li>
                                                                    <li className='text-center small bg-transparent pl-3 pr-3 text-secondary'>
                                                                        <span>{t('genDict.Quiz')}</span><br></br>
                                                                        <span>{curriculumItem?.quiz_count}</span>
                                                                    </li>
                                                                    <li className='text-center small bg-transparent pl-3 pr-3 text-secondary'>
                                                                        <span>{t('genDict.duration')}</span><br></br>
                                                                        <span>{Math.round((curriculumItem.duration_in_minutes)/60)}{t('genDict.h')}</span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div>
                                                                <a type="button" className='text-dark mr-3'
                                                                    onClick={() => {
                                                                        history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${RouteParams['id']}/curriculums/${curriculumItem.id}/edit`);
                                                                    } }><EditFilled /></a>
                                                                <a type="button"
                                                                    onClick={() => confirm({
                                                                        icon: <ExclamationCircleOutlined />,
                                                                        title: t('genDict.confirmDelete'),
                                                                        okText: t('genDict.ok'),
                                                                        cancelText: t('genDict.cancel'),
                                                                        content: `${t('genDict.confirmDelete')} "${curriculumItem.title}"`,
                                                                        okButtonProps: { loading: deletingItem, danger: true },
                                                                        onOk: async () => {
                                                                            setDeletingItem(true);
                                                                            API_SERVICE.removeCurriculum(RouteParams['id'], curriculumItem.id).then((d) => {
                                                                                notification.success({
                                                                                    message: t('genDict.success'),
                                                                                });
                                                                                refreshCurriculumItems();
                                                                            }).catch((e: any) => {
                                                                                notification.error({
                                                                                    message: t(API_SERVICE.handleErrors(e)),
                                                                                });
                                                                            }).finally(() => {
                                                                                setDeletingItem(false);
                                                                            });
                                                                        },
                                                                    })}><DeleteOutlined /></a>
                                                            </div>
                                                        </div>

                                                    </div></>} key={curriculumItem.id}>

                                                        {contentItems.length ?
                                                            // <div className="mt-4 content-table-div">
                                                            <div className={lang == 'ar' ? 'text-right mr-2' : 'mt-4 quiz-table-div'}>
                                                                <h5 className="mb-3">{t('genDict.content')}</h5>
                                                                <table className="table module-table p-2">
                                                                    <tbody>
                                                                        {contentItems && contentItems.map(contentItem => {
                                                                            if (contentItem.curriculum_id === curriculumItem.id && contentItem.type !== "quiz") {
                                                                                return <tr className="box-shadow mt-3">
                                                                                    <td>
                                                                                        <p className="mb-0 bold-500">{i = i + 1}.{contentItem.title}</p>
                                                                                        <p className="ml-3">{contentItem.description}</p>
                                                                                    </td>
                                                                                    {/* <td className="w-150 text-center">
                                                                                        <label className="w-100">Preview</label>
                                                                                        <Form.Item
                                                                                            initialValue={contentItem.is_preview === 1 ? true : false}
                                                                                            name="is_preview"
                                                                                            valuePropName={'checked'}
                                                                                            rules={[]}
                                                                                        >
                                                                                            <Switch disabled={!RouteParams['mode']} />
                                                                                        </Form.Item>
                                                                                    </td> */}
                                                                                    <td className="w-100px text-right" style={{ verticalAlign: 'middle' }}>
                                                                                        <span className="dropdown">
                                                                                            <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                                                                                                <img className='cursor-pointer' src={vDOts} style={{ width: '20px' }} />
                                                                                            </a>
                                                                                            <div className="dropdown-menu">
                                                                                                <a className="dropdown-item" role="button"
                                                                                                    onClick={() => {
                                                                                                        history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${contentItem?.course_id}/curriculums/${contentItem?.curriculum_id}/contents/${contentItem?.id}/View`)
                                                                                                    } }
                                                                                                >{t('genDict.view')}</a>
                                                                                                <a className="dropdown-item" role="button"
                                                                                                    onClick={() => {
                                                                                                        history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${contentItem?.course_id}/curriculums/${contentItem?.curriculum_id}/contents/${contentItem?.id}/edit`)
                                                                                                    } }
                                                                                                >{t('genDict.Edit')}</a>
                                                                                                <a className="dropdown-item" role="button"
                                                                                                    onClick={() => confirm({
                                                                                                        icon: <ExclamationCircleOutlined />,
                                                                                                        title: t('genDict.confirmDelete'),
                                                                                                        okText: t('genDict.ok'),
                                                                                                        cancelText: t('genDict.cancel'),
                                                                                                        content: `${t('genDict.confirmDelete')} "${contentItem.title}"`,
                                                                                                        okButtonProps: { loading: deletingItem, danger: true },
                                                                                                        onOk: async () => {
                                                                                                            setDeletingItem(true);
                                                                                                            API_SERVICE.removeContent(RouteParams['id'], moduleId, contentItem.id).then((d) => {
                                                                                                                notification.success({
                                                                                                                    message: t('genDict.success'),
                                                                                                                });
                                                                                                                refreshContentItems();
                                                                                                            }).catch((e: any) => {
                                                                                                                notification.error({
                                                                                                                    message: t(API_SERVICE.handleErrors(e)),
                                                                                                                });
                                                                                                            }).finally(() => {
                                                                                                                setDeletingItem(false);
                                                                                                            });
                                                                                                        },
                                                                                                    })}
                                                                                                >{t('genDict.delete')}</a>
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>;
                                                                            }
                                                                        })}
                                                                        <span className='d-none'>{(i = 0)}</span>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            : ''}
                                                        {contentItems.length ?
                                                            // <div className="mt-4 quiz-table-div">
                                                            <div className={lang == 'ar' ? 'text-right mr-2' : 'mt-4 quiz-table-div'}>
                                                                
                                                                <h5 className="mb-3">{t('genDict.Quiz')}</h5>
                                                                <table className="table module-table p-2">
                                                                    <tbody>
                                                                        {contentItems && contentItems.map(contentItem => {
                                                                            if (contentItem.curriculum_id === curriculumItem.id && contentItem.type === "quiz") {
                                                                                return <>
                                                                                    <tr className="box-shadow mt-3">
                                                                                        <td>
                                                                                            <p className="mb-0 bold-500">{iQuiz = iQuiz + 1}.{contentItem.title}</p>
                                                                                            <p className="ml-3">{contentItem.description}</p>
                                                                                        </td>
                                                                                        <td className="w-150 text-center" style={{ verticalAlign: 'middle' }}>
                                                                                            <p style={{ marginBottom: '6px' }}><span className="cursor-pointer text-blue" 
                                                                                            data-toggle="modal" data-target="#showQuesModal" 
                                                                                            onClick={() => { setQuizId(contentItem.id); refreshQuesItems(); } }
                                                                                            >{t('genDict.showQuestion')}</span></p>
                                                                                            {/* <img className='cursor-pointer' data-toggle="modal" data-target="#addQuestion" onClick={() => quizIdValue(contentItem.id)} src={plusIcon} style={{ width: '22px', background: '#4f46e5', padding: '5px', borderRadius: '50%' }} /> */}
                                                                                        </td>
                                                                                        <td className="w-150 text-center">
                                                                                            <label className="w-100 mb-0">{t('genDict.VideoQuiz')}</label>
                                                                                            <div>
                                                                                                {
                                                                                                    contentItem && contentItem?.isVideoQuiz == 0 ?
                                                                                                        <img src={CloseImg} style={{width : '20px'}} />
                                                                                                    : 
                                                                                                        <img src={OpenImg} style={{width : '20px'}} />
                                                                                                }
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="w-100px text-right" style={{ verticalAlign: 'middle' }}>
                                                                                            <span className="dropdown">
                                                                                                <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                                                                                                    <img className='cursor-pointer' src={vDOts} style={{ width: '20px' }} />
                                                                                                </a>
                                                                                                <div className="dropdown-menu">
                                                                                                    {contentItem?.isVideoQuiz === 0 && <a className="dropdown-item" role="button"
                                                                                                        onClick={() => {
                                                                                                            history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${contentItem?.course_id}/curriculums/${contentItem?.curriculum_id}/contents/${contentItem?.id}/View`)
                                                                                                        } }
                                                                                                    >{t('genDict.view')}</a>}
                                                                                                    <a className="dropdown-item" role="button"
                                                                                                        onClick={() => {
                                                                                                            history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${contentItem?.course_id}/curriculums/${contentItem?.curriculum_id}/contents/${contentItem?.id}/edit`)
                                                                                                        } }
                                                                                                    >{t('genDict.Edit')}</a>
                                                                                                    <a className="dropdown-item" role="button"
                                                                                                        onClick={() => confirm({
                                                                                                            icon: <ExclamationCircleOutlined />,
                                                                                                            title: t('genDict.confirmDelete'),
                                                                                                            okText: t('genDict.ok'),
                                                                                                            cancelText: t('genDict.cancel'),
                                                                                                            content: `${t('genDict.confirmDelete')} "${contentItem.title}"`,
                                                                                                            okButtonProps: { loading: deletingItem, danger: true },
                                                                                                            onOk: async () => {
                                                                                                                setDeletingItem(true);
                                                                                                                API_SERVICE.removeContent(RouteParams['id'], moduleId, contentItem.id).then((d) => {
                                                                                                                    notification.success({
                                                                                                                        message: t('genDict.success'),
                                                                                                                    });
                                                                                                                    refreshContentItems();
                                                                                                                }).catch((e: any) => {
                                                                                                                    notification.error({
                                                                                                                        message: t(API_SERVICE.handleErrors(e)),
                                                                                                                    });
                                                                                                                }).finally(() => {
                                                                                                                    setDeletingItem(false);
                                                                                                                });
                                                                                                            },
                                                                                                        })}
                                                                                                    >{t('genDict.delete')}</a>
                                                                                                </div>
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </>;
                                                                            }
                                                                        })}
                                                                        <span className='d-none'>{(iQuiz = 0)}</span>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            : ''}

                                                    </Panel>;
                                                })}
                                            </Collapse>
                                        </div>
                                    </TabPane>
                                    {/* <TabPane tab={t('genDict.meetings')} key="3">
                                        <MeetingsPage location={props.location} hideHeader={true} />
                                    </TabPane> */}
                                    {Parameters.Mode !== 'CLIENT' && <TabPane tab={t('genDict.reviews')} key="4">
                                        <ReviewsPage location={props.location} courseId={RouteParams['id']} hideHeader={true} />
                                    </TabPane>}
                                </Tabs>
                            </div>
                        </div>
                        <div className="modal" id="showQuesModal">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="close" id="closeQuesModal" data-dismiss="modal">&times;</button>
                                    </div>
                                    <div className="modal-body">
                                        {quesItems.length ?
                                            <>
                                                <div className="table-responsive table-br-5 box-shadow mt-2">
                                                    <table className="table  table-meetings table-report">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-uppercase text-secondary">{t('genDict.QuestionTitle')}</th>
                                                                <th className="text-uppercase text-secondary">{t('genDict.type')}</th>
                                                                <th className="text-uppercase text-secondary text-center">{t('genDict.status')}</th>
                                                                <th className="text-uppercase text-secondary" style={{ width: '100px' }}>{t('genDict.action')}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {quesItems && quesItems.map(quesItem => {
                                                                if (quesItem.content_id === quizId) {
                                                                    return <tr>
                                                                        <td className="text-secondary">
                                                                            <div dangerouslySetInnerHTML={{__html: quesItem.title}} /></td>
                                                                        <td>
                                                                            {quesItem.type === 'radio' ? t('question.singleSelect') : quesItem.type === 'checkbox' ? t('question.multiSelect') : t('question.numeric')}
                                                                        </td>
                                                                        <td className="text-center">{quesItem.status === 'ACTIVE' ? <img src={activeBadge} /> : <img src={inactiveBadge} />}</td>
                                                                        <td className="text-secondary">
                                                                            <div className='d-flex align-items-center'>
                                                                                <div className='mr-3'>
                                                                                    <Button type="primary" danger={true} shape="circle" icon={<DeleteOutlined />}
                                                                                        onClick={() => {
                                                                                            let showQuisClose = document.getElementById("closeQuesModal") as HTMLElement
                                                                                            showQuisClose.click()

                                                                                            confirm({
                                                                                                icon: <ExclamationCircleOutlined />,
                                                                                                title: t('genDict.confirmDelete'),
                                                                                                okText: t('genDict.ok'),
                                                                                                cancelText: t('genDict.cancel'),
                                                                                                content: `${t('genDict.confirmDelete')} "${quesItem.title}"`,
                                                                                                okButtonProps: { loading: deletingQuesItem, danger: true },
                                                                                                onOk: async () => {
                                                                                                    setDeletingQuesItem(true);
                                                                                                    API_SERVICE.removeQuestion(RouteParams['courseId'], RouteParams['curriculumId'], RouteParams['id'], quesItem.id).then((d) => {
                                                                                                        notification.success({
                                                                                                            message: t('genDict.success'),
                                                                                                        });
                                                                                                        refreshQuesItems();
                                                                                                    }).catch((e: any) => {
                                                                                                        notification.error({
                                                                                                            message: t(API_SERVICE.handleErrors(e)),
                                                                                                        });
                                                                                                    }).finally(() => {
                                                                                                        setDeletingQuesItem(false);
                                                                                                    });
                                                                                                },
                                                                                            })
                                                                                        }
                                                                                        } />
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>;
                                                                }
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </>
                : <>
                    {setFetching(true)}
                        {/* {(user?.role?.slug === 'STUDENT') && <h5 className="text-center mt-5 mb-5">Permission Denied</h5>} */}

              </>
            )}
        </AuthConsumer>
    );
}
